import type { Component } from 'solid-js'
import Icon from '~/components/Icon'
import { useAppState } from '~/contexts/ThemeContext'
import Button from '../components/Button'

const ThemeToggle: Component = () => {
  const { isDark, toggleTheme: handleToggleTheme } = useAppState()

  return (
    <Button
      variant="text"
      color="default"
      class="p-2! h-9 w-9"
      aria-label={isDark() ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
      id="theme-toggle"
      onClick={handleToggleTheme}
      title={isDark() ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
    >
      {isDark() ? (
        <Icon icon="material-symbols-light:sunny-outline" width={28} class="text-yellow-600 dark:text-yellow-400" />
      ) : (
        <Icon icon="material-symbols-light:dark-mode-outline" width={28} class="text-foreground-subtle" />
      )}
    </Button>
  )
}

export default ThemeToggle
